import React from 'react';
import { FadeIn } from './FadeIn';
import { HeartPulseIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
export function Problems() {
  const problems = [{
    icon: <HeartPulseIcon size={32} className="text-nova-cyan" data-id="element-158" />,
    title: '¿Miedo al dentista?',
    description: 'Transformamos la ansiedad en tranquilidad. Utilizamos técnicas de sedación consciente y un ambiente relajante con aromaterapia y música para que tu visita sea un placer.'
  }, {
    icon: <ShieldCheckIcon size={32} className="text-nova-cyan" data-id="element-159" />,
    title: 'Tecnología Sin Dolor',
    description: 'Olvídate de las molestias. Nuestra clínica está equipada con anestesia computarizada y láser dental de última generación para tratamientos rápidos y 100% indoloros.'
  }, {
    icon: <SparklesIcon size={32} className="text-nova-cyan" data-id="element-160" />,
    title: 'Inseguridad al Sonreír',
    description: 'Recupera tu confianza. Diseñamos sonrisas perfectas que armonizan con tu rostro, mejorando no solo tu estética sino tu autoestima y calidad de vida.'
  }];
  return <section className="py-24 relative z-10" data-id="element-161">
      <div className="max-w-7xl mx-auto px-6" data-id="element-162">
        <FadeIn className="text-center max-w-2xl mx-auto mb-16" data-id="element-163">
          <h2 className="text-4xl md:text-5xl font-black text-nova-dark mb-6 tracking-tight" data-id="element-164">
            Entendemos tus preocupaciones
          </h2>
          <p className="text-lg text-nova-gray" data-id="element-165">
            Hemos rediseñado por completo la experiencia odontológica para
            eliminar todo lo que no te gusta de ir al dentista.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-166">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-167">
              <div className="glass-panel p-8 h-full hover:-translate-y-2 transition-transform duration-300" data-id="element-168">
                <div className="w-16 h-16 rounded-2xl bg-nova-cyan/10 flex items-center justify-center mb-6" data-id="element-169">
                  {problem.icon}
                </div>
                <h3 className="text-2xl font-bold text-nova-dark mb-4" data-id="element-170">
                  {problem.title}
                </h3>
                <p className="text-nova-gray leading-relaxed" data-id="element-171">
                  {problem.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}